export default __webpack_public_path__ + "static/media/PreviewBordor.8cd955fd.svg";